import React from 'react';

const Terms = () => (
  <main className="max-w-3xl mx-auto px-4 py-20 text-gray-800 dark:text-gray-200">
    <h1 className="text-3xl sm:text-4xl font-bold mb-6">Termeni și condiții</h1>
    <p className="mb-4">Prin folosirea acestui site și/sau achiziționarea serviciilor, ești de acord cu termenii de mai jos.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">1. Servicii</h2>
    <p className="mb-4">Serviciile sunt livrate în principal online: plan de antrenament în aplicația mobilă și plan alimentar prin email/WhatsApp. 1‑la‑1 în sală este disponibil separat, la cerere.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">2. Plată și livrare</h2>
    <p className="mb-4">Plata se efectuează în avans (Revolut/BT Pay). Planurile sunt livrate în maximum 2 zile lucrătoare de la confirmarea plății.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">3. Răspundere</h2>
    <p className="mb-4">Utilizezi serviciile pe propria răspundere. Recomandăm acordul medicului înainte de a începe un program de nutriție/antrenament.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">4. Drepturi de autor</h2>
    <p className="mb-4">Planurile și materialele primite sunt destinate uzului personal și nu pot fi redistribuite fără acordul nostru scris.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">5. Confidențialitate</h2>
    <p className="mb-4">Datele personale sunt prelucrate conform Politicii de confidențialitate.</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">6. Modificări</h2>
    <p className="mb-4">Ne rezervăm dreptul de a actualiza periodic acești termeni. Versiunea curentă este disponibilă pe site.</p>
  </main>
);

export default Terms; 